import { useContext } from 'react';
import Link from 'next/link';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';
import { FieldValues, FormProvider, SubmitHandler, useForm, UseFormReturn } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { signInSchema } from '@/validation';
import { PAGE } from '@/router/routes';
import { Fetch } from '@/services/index';
import { protectedRoutePropsWrapper, BasePageProps } from '@/utils/index';
import UserContext from '@/context/UserContext';

import { AuthLayout } from '@/components/layouts';
import { PaymentInput } from '@/components/shared/Inputs';
import { PaymentButton } from '@/components/shared/Buttons';

const SignIn: NextPage = () => {
  const router = useRouter();
  const { setUser } = useContext(UserContext);

  const methods: UseFormReturn = useForm({
    resolver: yupResolver(signInSchema),
    mode: 'onChange',
  });

  const onEmailLogin: SubmitHandler<FieldValues> = async ({ email, password }) => {
    try {
      const response = await Fetch.getEmailSignin({
        password,
        email,
      });

      Cookies.set('token', response?.data?.meta?.token);
      const userRes = await Fetch.getUser();
      setUser(userRes?.data?.data);

      router.push(PAGE.OPTIONS_SIGNUP);
    } catch {}
  };

  return (
    <AuthLayout>
      <h1 className="font-stag text-2xl font-bold md:text-[46px]">Login</h1>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onEmailLogin)}>
          <div className="mt-6 flex flex-col space-y-4">
            <PaymentInput name="email" placeholder="Email" type="email" />
            <PaymentInput name="password" placeholder="Password" type="password" />

            <div className="!mt-3 flex justify-end text-base">
              <Link href={PAGE.RESET_PASSWORD}>
                <span className="cursor-pointer hover:text-brand-primary">Forgot Password?</span>
              </Link>
            </div>
            <PaymentButton type="submit" disabled={methods.formState.isSubmitting}>
              Login
            </PaymentButton>
          </div>
        </form>
      </FormProvider>
      <div className="mt-4 flex justify-center text-base">
        <Link href={PAGE.MAGIC_LINK_LOGIN}>
          <span className="cursor-pointer hover:text-brand-primary">Log in without password</span>
        </Link>
      </div>
    </AuthLayout>
  );
};
export default SignIn;

export const getServerSideProps = protectedRoutePropsWrapper(async (props: BasePageProps) => {
  if (props.user) {
    return {
      redirect: {
        permanent: false,
        destination: PAGE.HOME,
      },
      props: {},
    };
  }

  return {
    props: {},
  };
});
